import React, { Component } from "react";
import "./App.css";
import AppRouter from "./router";
import { ToastContainer, Zoom } from "react-toastify";
import { Store } from "./redux";
import { Provider } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import InstallPrompt from "install-prompt-banner";
import { socket, urls } from "./backend/notifications";

class App extends Component {
  constructor() {
    super();
    this.installPromptBanner = new InstallPrompt();
    this.state = { deferredPrompt: null, installBanner: false };
  }

  componentDidMount() {
    this.installPromptBanner.checkPrompt();
    let deferredPrompt;
    window.addEventListener("beforeinstallprompt", e => {
      console.log("beforeinstallpropmt listener");
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      // Stash the event so it can be triggered later.
      deferredPrompt = e;
      this.setState({ deferredPrompt, installBanner: true });
    });

    // Register websocket
    this.socket = new socket({ url: urls.prod }).open();
  }

  componentWillUnmount() {
    if (this.socket) this.socket.close();
  }

  render() {
    return (
      <Provider store={Store()}>
        <AppRouter>
          <ToastContainer transition={Zoom} />
        </AppRouter>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js